export default "assets/images/icons/slider-arrow-05730884.png";